/**
 * Map SED evidence conflicts onto Coverage Matrix requirements.
 */
import type { SiteEvidenceDocument } from '../../types/siteEvidence';
import type { FieldPath } from '../evidenceLineage/requirementToFields';
import { REQUIREMENT_TO_FIELDS } from '../evidenceLineage/requirementToFields';
import type { EvidenceConflict } from '../../services/evidenceConflict';
import type { RequirementStatus } from './requirementStatus';

export function unresolvedConflictsForRequirement(
  sed: SiteEvidenceDocument | undefined,
  requirementId: string,
): EvidenceConflict[] {
  if (!sed?.evidenceConflicts?.length) return [];
  const fieldPaths = new Set(REQUIREMENT_TO_FIELDS[requirementId] ?? []);
  return sed.evidenceConflicts.filter(c => {
    if (c.userResolution || c.resolvedAt) return false;
    const path = `${c.sectionId}.${c.field}` as FieldPath;
    return fieldPaths.has(path);
  });
}

export function capRequirementStatusForConflicts(
  status: RequirementStatus,
  hasConflicts: boolean,
): RequirementStatus {
  if (!hasConflicts) return status;
  if (status === 'authored-strong' || status === 'strong') return 'adequate';
  return status;
}
